export const initState = {
    app_version: process.env.REACT_APP_VERSION
}

const authReducer = (state = initState, action) => {
    switch (action.type) {
        default:
            return state;
    }
}

export default authReducer;